import React from 'react';

function isChecked(value) {
  return value === true || value === 1 || value === '1';
}

export default function ControladorMonitoramentoToggle(props) {
  const { input, icon, title, description, readOnly, disabled } = props;
  const checked = isChecked(input.value);
  const isReadOnly = Boolean(readOnly);
  const isDisabled = Boolean(disabled);

  return (
    <label
      className={`controlador-monitoramento-toggle ${checked ? 'is-active' : ''} ${isReadOnly ? 'is-readonly' : ''} ${
        isDisabled ? 'is-disabled' : ''
      }`}
    >
      <input
        {...input}
        type="checkbox"
        checked={checked}
        disabled={isDisabled}
        readOnly={isReadOnly}
        onChange={event => {
          if (isReadOnly || isDisabled) return;
          input.onChange(event.target.checked);
        }}
      />
      <div className="controlador-monitoramento-toggle-icon">
        <i className={`fa ${icon}`} />
      </div>
      <div className="controlador-monitoramento-toggle-content">
        <strong>{title}</strong>
        <span>{description}</span>
      </div>
      <div className="controlador-monitoramento-toggle-switch" aria-hidden="true">
        <span />
      </div>
    </label>
  );
}
